export type ClientUserRole = 'ClientAdmin' | 'ClientViewer';

export interface PortalUser {
  id: string;
  clientId: string;
  email: string;
  fullName: string | null;
  role: ClientUserRole;
}

export interface PortalAmbiguousClientHint {
  clientId: string;
  clientCode: string;
  clientName: string;
}

export type PortalLoginError =
  | { kind: 'invalid_credentials'; message: string }
  | { kind: 'lockout'; message: string }
  | { kind: 'account_disabled'; message: string }
  | { kind: 'ambiguous'; hints: PortalAmbiguousClientHint[] }
  | { kind: 'network'; message: string };

export interface PortalAuthContextValue {
  user: PortalUser | null;
  isAuthenticated: boolean;
  isBootstrapping: boolean;
  login: (
    email: string,
    password: string,
    clientIdHint?: string,
  ) => Promise<PortalLoginError | null>;
  logout: () => Promise<void>;
  refresh: () => Promise<string | null>;
}

export const ClientUserRoleRank: Record<ClientUserRole, number> = {
  ClientViewer: 1,
  ClientAdmin: 2,
};
